import { Label, makeStyles } from "@fluentui/react-components";
import { Checkmark20Regular, Dismiss20Regular } from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { IInactiveWorkspacesInTenantReportSummaryProps } from "./inactive-workspaces-in-tenant-report-summary.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexDirection: 'column'
    },
    inlineSection: {
        display: 'flex',
        flexDirection: 'row',
        gap: '2em',
        marginBottom: '1em'
    },
    inlineItem: {
        display: 'flex',
        flexDirection: 'column'
    },
    section: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: '1em'
    },
    checkboxRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5em',
        marginBottom: '0.5em'
    }
});

export default function InactiveWorkspacesInTenantReportSummary(props: IInactiveWorkspacesInTenantReportSummaryProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    return (
        <div className={styles.mainWrapper}>
            {props.report?.details && (
                <>
                    <div className={styles.inlineSection}>
                        <div className={styles.inlineItem}>
                            <Label>{t("ppaInactivityDays")}</Label>
                            <span>{props.report.details.inactivityDays}</span>
                        </div>
                        <div className={styles.inlineItem}>
                            <Label>{t("ppaWorkspaceCount")}</Label>
                            <span>{props.report.details.workspaceCount}</span>
                        </div>
                    </div>

                    <div className={styles.section}>
                        <div className={styles.checkboxRow}>
                            {props.report.details.includedWorkspaces ? (
                                <Checkmark20Regular />
                            ) : (
                                <Dismiss20Regular />
                            )}
                            <span>{t("ppaPersonalSiteFilterIncludeWorkspacesLabel")}</span>
                        </div>
                        <div className={styles.checkboxRow}>
                            {props.report.details.includedOneDrives ? (
                                <Checkmark20Regular />
                            ) : (
                                <Dismiss20Regular />
                            )}
                            <span>{t("ppaPersonalSiteFilterIncludeOneDriveLabel")}</span>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}
